import axios from 'axios';
import config from '../config';
import {sessionID} from '../../utils/handlingSession';
import Cookies from 'universal-cookie';
import { getEmailFromStorage } from '../../utils/helpers/storageUtils';
export const frontEndLogs = async (logDescription,critical,statusCode,methodName, error_message="") => {

     const cookie = new Cookies();
     let url = config.hummBackendAppURL+'user-logs/logs';
     let date =  new Date().toJSON().replace("T",' ').replace("Z",'+00');
     let user = ((localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere'))) ? 'apply_now': 'login';

     let email = getEmailFromStorage();

     let obj = {
        "userId":sessionID().session_id, 
        "log_description":  logDescription,
        "logtypeLogTypeId": "", 
        "status_code": statusCode,
        "critical":   critical,
        "class_name": "",  
        "module_name": window.location.href,
        "method_name": methodName, 
        "line_number": "", 
        "device_id": "",
        "session_id": sessionID().session_id, 
        "login_type": user,
        "ip_address": "", 
        "created_date": date,
        "build_number": "",
        "device_type": "web",            
        "api_endpoint": "",
        "error_message":error_message,
        "request_payload": "",
        "customer_email": email,
        "application_id": sessionStorage.getItem('applicationId') ? sessionStorage.getItem('applicationId') :cookie.get('applicationId'),
        "user_tracking_id": sessionStorage.getItem('user_tracking_id'),
        "uuid": sessionStorage.getItem('uuid') || ""
    }
    return await axios.post(url,obj,{headers:sessionID()}).then(res => {
        return res
    })
    .catch(err => {
        return err.response
    })


};